import { Stack, Typography, Paper } from "@mui/material";
import RenderizadorDeImagem from "./RenderizadorDeImagem";


const MeuCorre = ({ manchete, resumo, texto, imagem }) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      width={"100%"}
      sx={{ minHeight: "100vh", backgroundColor: "#f5f0e1", padding: 2 }}
    >
      
    </Stack>
  );
};

export default MeuCorre;
